import '../../styles/index.css'
import PreçoPrincipal from '../Preços/PreçoPrincipal/PreçoPrincipal';
import './DescriçãoProduto.css';

function DescriçãoProduto({nome, preço, preçoParcelado, qtdOfertas}) {
    return (
        <div className='descricaoDoProduto'>

            <p className='b1 text-start negrito'>{nome}</p>

            <PreçoPrincipal preço={preço} preçoParcelado={preçoParcelado} />

            <div>

                <p className='b2'>{

                    qtdOfertas > 1 ? `Menor Preço entre ${qtdOfertas} Lojas` : `Menor Preço entre ${qtdOfertas} Loja`

                }</p>

                <a href='#secao-mais-precos'><p className='bt2'>Ver lojas e ofertas</p></a>

            </div>

        </div>
    );
}

export default DescriçãoProduto;
